import React from "react";
import BaseInput from "../BaseInput";
import { makeStyles } from "../../hooks/make-styles-wrapper";

const commonStyles = (theme) => ({
    width: "288px",
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
    },
    "&input[type=number]": {
        "-moz-appearance": "textfield",
    },

    [theme.breakpoints.between(350, 400)]: {
        width: "320px",
    },
    [theme.breakpoints.between(400, 500)]: {
        width: "350px",
    },
    [theme.breakpoints.up(500)]: {
        width: "400px",
    },
});

const useStyles = makeStyles(
    (theme, overrides, merge) => ({
        root: merge(
            commonStyles(theme),
            {
                "& label.Mui-focused": {
                    color: theme.palette.primary.main,
                },
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        borderColor: theme.palette.grey.dark,
                    },
                    "&.Mui-focused fieldset": {
                        borderColor: theme.palette.primary.main,
                    },
                },
            },
            overrides,
        ),
    }),
    "textInput.chat",
);

const useErrorStyles = makeStyles(
    (theme, overrides, merge) => ({
        root: merge(
            commonStyles(theme),
            {
                "& label.Mui-focused": {
                    color: theme.palette.error.main,
                },
                "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                        borderColor: theme.palette.error.main,
                    },
                },
            },
            overrides,
        ),
    }),
    "textInput.error",
);

const TextInput = (props) => {
    const styles = useStyles();
    const errorStyles = useErrorStyles();
    return (
        <BaseInput
            classes={(props.error) ? errorStyles : styles}
            {...props}
        />
    );
};

export default TextInput;
